export default __webpack_public_path__ + "static/media/d_profile.471ece35.png";